const subAccountStatus = {
  ACTIVE: 'HABILITADA',
  REMOVED: 'REMOVIDA',
  BLOCKED: 'BLOQUEADA',
  ANALYSIS: 'EM_ANALISE',
  REJECTED: 'REJEITADA'
};

module.exports = subAccountStatus;
